<link rel="ractive" href="./package-header.html" name="c-package-header">

<div class="c-search-compact {{#if searchOpened }}active{{/if}}">
	<div class="search-input-wrapper">
		<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/magnifier.svg">
		<input
			type="text"
			class="search-input"
			on-focus="@this.set('inputFocused', true)"
			on-blur="@this.set('inputFocused', false)"
			on-keydown="@this.onKeyDown(@event)"
			placeholder="search all of npm"
			value="{{query}}"
			spellcheck="false">
	</div>

	<div class="c-search-compact-overlay" on-click="@this.set('searchOpened', false)"></div>

	{{#if searchOpened }}
		<div class="c-search-compact-wrapper" tabindex="-1">
			<div class="search-results">
				{{#each packages:packIdx}}
					<div class="c-package-header-wrapper {{#if currSelectedItemIdx == packIdx}}selected{{/if}}">
						<c-package-header
							package="{{this}}"
							version="{{version}}"
							query="{{query}}"
							searchOpened={{searchOpened}}
							packageNameAsLink="true"
							showDownloads="true">
						</c-package-header>
					</div>
				{{elseif query && nbHits === 0}}
					<p class="c-search-compact-empty">No results found</p>
				{{/each}}
			</div>

			{{#if query && nbHits !== 0}}
				<nav class="search-pagination" aria-label="Search results pagination">
					<ul class="pagination">
						<li style="{{#unless page}}visibility: hidden;{{/unless}}">
							<a on-click="page > 0 && @this.subtract('page')" aria-label="Previous">
								<span aria-hidden="true">&laquo;</span>
							</a>
						</li>

						{{#each pagination(page, nbPages)}}
							<li class="{{#if page === this}}active{{/if}}"><a on-click="@this.handlePagination(this)">{{this + 1}}</a></li>
						{{/each}}

						<li style="{{#unless page + 1 < nbPages}}visibility: hidden;{{/unless}}">
							<a on-click="page + 1 < nbPages && @this.add('page')" aria-label="Next">
								<span aria-hidden="true">&raquo;</span>
							</a>
						</li>
					</ul>
				</nav>
			{{/if}}

		</div>
	{{/if}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const debounce = require('../../assets/js/utils/debounce');
	const search = require('../../assets/js/utils/search');

	component.exports = {
		data () {
			return {
				_,
				page: 0,
				query: '',
				packages: [],
				currSelectedItemIdx: null,
				pagination (page, nbPages) {
					let start = Math.max(page - 2, 0);
					let pages = [];

					if (nbPages - page === 1) {
						start = Math.max(Math.min(start, start - 1, start - 2), 0);
					} else if (nbPages - page === 2) {
						start = Math.max(Math.min(start, start - 1), 0);
					}

					for (let i = 0; i < 5 && start + i < nbPages; i++) {
						pages.push(start + i);
					}

					return pages;
				},
			};
		},
		onrender () {
			if (!this.isServer) {
				let offsetTop = pageYOffset;
				scrollTo(0, offsetTop);

				let s = debounce((keypath) => {
					if (this.get('query')) {
						search(this.get('query'), this.get('page'), 5).then((result) => {
							// The query might have changed since we sent the request.
							if (result.query === this.get('query')) {
								this.set('packages', result.response.hits, { shuffle: 'name' });

								if (this.get('inputFocused')) {
									this.set('searchOpened', true);
								}

								this.set({
									fadeIn: true,
									nbPages: result.response.nbPages,
									nbHits: result.response.nbHits,
								});

								// Scroll to the results.
								if (!pageYOffset || keypath === 'page') {
									this.scrollToSearch();
								}
							}
						});
					}
				}, 40);

				// Make sure query is always a string.
				this.observe('query', (value) => {
					if (typeof value !== 'string') {
						this.set('query', String(value));
					}
				});

				// Update results on input.
				this.observe('page query __ready', (newValue, oldValue, keypath) => {
					// Don't send requests before have all the data.
					if (this.get('__ready')) {
						// Reset page on query change.
						if (keypath === 'query' && this.get('page') !== 0) {
							this.set('page', 0);
						} else if (!this.get('query')) {
							this.set('searchOpened', false);
							this.set('packages', []);
						} else {
							s(keypath);
						}
					}
				});

				// handle search input focus/blur
				this.observe('inputFocused', (isFocused) => {
					if (isFocused) {
						this.set('searchOpened', !!this.get('query'));
					} else {
						let selectedEl = document.querySelector('.c-package-header-wrapper.selected');

						if (selectedEl) {
							selectedEl.classList.remove('selected');
						}

						this.set('currSelectedItemIdx', null);
					}
				});

				// check if pagackes received and searchResults is opened
				this.observe('searchOpened packages', () => {
					let searchOpened = this.get('searchOpened');
					let packages = this.get('packages');

					if (searchOpened && packages.length) {
						this.set('searchResulsOpened', true);
					}
				});

				// once packages is received and search opened add listener to handle keyDown
				this.observe('searchResulsOpened', (isOpened) => {
					if (isOpened) {
						setTimeout(() => {
							let searchResultsEl = this.find('.c-search-compact-wrapper');

							searchResultsEl.addEventListener('keydown', (e) => {
								this.onKeyDown(e);
								e.preventDefault();
							});
						}, 4);
					}
				});
			}
		},
		onKeyDown (e) {
			let listEl = this.find('.c-search-compact-wrapper');

			if (!listEl) { return; }

			let selectedItemEl = listEl.querySelector('.c-package-header-wrapper.selected');
			let currSelectedItemIdx = this.get('currSelectedItemIdx');
			let packages = this.get('packages');

			if (e.key === 'ArrowDown') {
				currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx + 1 > packages.length - 1 ? 0 : currSelectedItemIdx + 1;

				this.set('currSelectedItemIdx', currSelectedItemIdx);
			} else if (e.key === 'ArrowUp') {
				currSelectedItemIdx = currSelectedItemIdx === null ? packages.length - 1 : currSelectedItemIdx - 1 < 0 ? packages.length - 1 : currSelectedItemIdx - 1;

				this.set('currSelectedItemIdx', currSelectedItemIdx);
			} else if (e.key === 'Enter') {
				// if there is a selected element then go to the selected package page
				if (currSelectedItemIdx !== null) {
					app.router.dispatch(`/package/npm/${selectedItemEl.querySelector('.package-name').textContent}`);

					return;
				}

				// otherwise navigate to the main page search
				this.goTo(this.get('query'));
			}
		},
		goTo (query) {
			app.router.dispatch(`/?query=${encodeURIComponent(query)}`, { state: { caretPosition: this.find('.search-input').selectionStart } });
		},
		scrollToSearch () {
			scrollTo({
				top: 0,
				left: Math.floor(this.find('.search-input').getBoundingClientRect().top / 100) * 100,
				behavior: 'smooth',
			});
		},
		handlePagination (pageNumber) {
			this.set('page', pageNumber);
			this.set('currSelectedItemIdx', 0);
		},
	};
</script>
